import script from "./DocPreview.vue?vue&type=script&setup=true&lang=js"
export * from "./DocPreview.vue?vue&type=script&setup=true&lang=js"

import "./DocPreview.vue?vue&type=style&index=0&id=12e3afb0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12e3afb0"]])

export default __exports__